export const flushErrors = Object.freeze({
	USER_PROFILE_INCOMPLETE: {
		code: "user_profile_incomplete",
		message: "Please complete your profile.",
	},
	PUBLISHER_PROFILE_INCOMPLETE: {
		code: "publisher_profile_incomplete",
		message:
			"Please complete the profile of your publishing house. You may need to contact your Senior Publisher to complete the profile if you don't have the permission.",
	},
	PUBLISHER_PENDING_APPROVAL: {
		code: "publisher_pending_approval",
		message:
			"Your publishing house is awaiting approval. Portal access will be available once it is approved.",
	},
	PUBLISHER_NOT_APPROVED: {
		code: "publisher_not_approved",
		message:
			"Your publishing house was not approved. Please contact support if you believe this is an error.",
	},
	INSTITUTION_PROFILE_INCOMPLETE: {
		code: "institution_profile_incomplete",
		message:
			"Please complete the profile of your institution. You may need to contact your institution admin to complete the profile if you don't have the permission.",
	},
});

const legacyCodes = Object.freeze({
	error_1: flushErrors.PUBLISHER_PROFILE_INCOMPLETE.message,
	error_2: flushErrors.USER_PROFILE_INCOMPLETE.message,
	error_3: flushErrors.INSTITUTION_PROFILE_INCOMPLETE.message,
});

export function getFlushErrorMessage(errorCode) {
	if (!errorCode) {
		return "";
	}

	const match = Object.values(flushErrors).find((error) => error.code === errorCode);
	if (match) {
		return match.message;
	}

	return legacyCodes[errorCode] || "";
}

/**
 * Check if the status code is 401
 */
export function isNotAuthenticated(statusCode) {
	return statusCode === 401;
}
